var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusypassage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 44,
    viewBox: "0 0 41 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9123 1.6042C13.0259 2.48953 9.838 3.20508 9.82998 3.21393C9.81392 3.21398 9.80607 3.38175 9.8063 3.59365L9.80672 3.97329L10.7709 4.29718L11.7351 4.62106L17.3239 3.36882C20.3993 2.68008 22.9448 2.14297 22.985 2.16934C23.0252 2.19571 23.0663 10.3448 23.0793 22.052L23.1012 41.8996L23.7038 42.0303L24.3063 42.161L24.283 21.0774C24.2608 1.05318 24.2516 -0.00627275 24.1231 0.0029283C24.0428 0.00316082 20.7987 0.727704 16.9123 1.6042Z",
    fill: "#168AF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6714 21.1075L24.6951 42.1246L25.0458 41.9029L25.3884 41.6723L25.3897 21.0966L25.3829 0.52098L25.0561 0.301142C24.8764 0.178024 24.7131 0.0813514 24.6886 0.0814212C24.6641 0.081491 24.6584 9.53925 24.6714 21.1075Z",
    fill: "#168AF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0376458 22.1266L0.0609791 42.87L0.371203 42.9574C0.534486 43.0099 0.69776 43.0536 0.738566 43.0535C0.77121 43.0534 0.785145 33.6751 0.772251 22.2128L0.748809 1.3723L0.381556 1.37335L0.0143024 1.37439L0.0376458 22.1266Z",
    fill: "#168AF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16099 22.2239C1.17353 33.6758 1.2079 43.0527 1.24808 43.0525C1.28022 43.0525 3.59337 42.2865 6.38038 41.3425L11.4645 39.6238L11.4214 22.2827L11.3863 4.95045L6.50741 3.26036C3.8228 2.33214 1.51596 1.52645 1.37932 1.48269L1.13818 1.38626L1.16099 22.2239ZM2.88917 22.8812C3.82976 23.3641 3.33373 25.2992 2.37713 24.8693C1.66972 24.5446 1.66831 23.2555 2.37493 22.8562C2.61581 22.7142 2.57564 22.7143 2.88917 22.8812Z",
    fill: "#168AF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3886 23.1549C2.20404 23.2349 2.03599 23.7209 2.08447 24.0032C2.19753 24.6031 2.69547 24.7958 3.00808 24.3624C3.42489 23.7786 2.97435 22.8972 2.3886 23.1549Z",
    fill: "#168AF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusypassage);
export default __webpack_public_path__ + "static/media/busypassage.9f3f291e5af04e2403745b12f4178f08.svg";
export { ForwardRef as ReactComponent };